import React from 'react';

import './Button.sass';

type StandardButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

const Button: React.StatelessComponent<StandardButtonProps> = ({ className, children, ...props }) => (
    // put spread operator first so redundant values are ovewriten by the attributes that follow it
    <button {...props} className={`btn btn-rect ${className}`} type="button" >{children}</button>
);

Button.defaultProps = {
    className: ''
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/global/form/Button.tsx